export default __webpack_public_path__ + "img/love-arrow.c12d1e2e.svg";